<template>
  <div id="app">
    <div id="navbar_top">
        <a id="rwd_nav" href="#m_nav"></a>
    </div>
    <div id="wrap">
        <header>
            <div id="topnav_wrap">
                <div id="topnav_c">
                    <!--###導覽列區塊###-->
                    <div id="topnav">
                        <router-link :to="{name:'首頁'}"><span>首頁</span></router-link>
                        <router-link :to="{name:'網站導覽'}"><span>網站導覽</span></router-link>
                        <!--<a href="javascript:addBookmarkForBrowser('白金科技股份有限公司','http%3A%2F%2Fwww.ptotinc.com%2Fmember%2Fptotinc%2Fportal_c2_cnt.php%3Fowner_num%3Dc2_38424%26button_num%3Dc2%26folder_id%3D2285');">
                            <span style="">加入最愛</span>
                        </a>-->
                        <div id="language">
                            <a href="http://www.ptotinc.com:8080/#/" class='L3'>
                                <span style="">English</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="page_top">

                <!--###logo區塊###-->
                <div id="logo">
                    <h1>
                        <router-link :to="{name:'首頁'}"><img src="~@/assets/logo.png" alt="白金科技股份有限公司" title="白金科技股份有限公司" align="absmiddle"/></router-link>
                    </h1>
                </div>

                <div id="m_nav">
                    <div id="menu">
                        <ul class="menu">
                            <li v-bind:class="[false ? 'current' : '']">
                                <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>

                                <div>
                                    <ul>

                                        <li>
                                            <router-link :to="{name:'公司簡介'}"><span>公司簡介</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'經營理念'}"><span>經營理念</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'核心競爭力'}"><span>核心競爭力</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'企業沿革'}"><span>企業沿革</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'企業社會責任'}"><span>企業社會責任</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'產業新聞'}"><span>產業新聞</span></router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li v-bind:class="[false ? 'current' : '']">
                                <router-link :to="{name:'產品與服務'}"><span>產品與服務</span></router-link>

                            </li>

                            <li v-bind:class="[false ? 'current' : '']">
                                <router-link :to="{name:'工作環境'}"><span>人才招募</span></router-link>

                                <div>
                                    <ul>

                                        <li>
                                            <router-link :to="{name:'工作環境'}"><span>幸福白金</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'加入白金'}"><span>加入白金</span></router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li v-bind:class="[false ? 'current' : '']">
                                <router-link :to="{name:'營業據點'}"><span>聯絡我們</span></router-link>

                                <div>
                                    <ul>

                                        <li>
                                            <router-link :to="{name:'營業據點'}"><span>營業據點</span></router-link>
                                        </li>

                                        <li>
                                            <router-link :to="{name:'聯絡方式'}"><span>聯絡方式</span></router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                        </ul>
                    </div>

                    <a href="javascript:$.pageslide.close()" class="bars_close"></a>
                </div>

            </div>
        </header>
        <main>
        <!-- <p>
            <router-link to="/">Home</router-link>
            <router-link :to="{name: '公司簡介'}">公司簡介</router-link>
            <router-link :to="{name: '經營理念'}">經營理念</router-link>
            <router-link :to="{name: '核心競爭力'}">核心競爭力</router-link>
            <router-link :to="{name: '企業沿革'}">企業沿革</router-link>
            <router-link :to="{name: '企業社會責任'}">企業社會責任</router-link>
            <router-link to="/login">Login</router-link>
        </p> -->
        <router-view></router-view>
        </main>

        <!--###版權宣告區塊###-->
        <div id="twjp001_time"></div>
        <div id="footer">
            <div id="footer_c">
                <div class="s631_footer_w">
                    <div class="s631_footer_w" style="text-align: center; width: 100%;">
                        <h3>白金科技股份有限公司</h3>

                        <p>地址 : 桃園市龜山區華亞科技園區科技二路37號<br>
                        電話 : +886-3-211-5526<br>
                        傳真 : +886-3-211-5293<br>
                        Mail :&nbsp;steven.chen@ptotinc.com</p>
                        Copyright © 2022 白金科技股份有限公司. All Rights Reserved.
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    setCurrentMenu(v) {
    },

    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default',"%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@使數位影像呈現地球自然的顏色%%%#fff%%%%%%置中@@@","%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@");
      // initVideo();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue